import { render, staticRenderFns } from "./outpost.vue?vue&type=template&id=8a42c810"
import script from "./outpost.vue?vue&type=script&lang=js"
export * from "./outpost.vue?vue&type=script&lang=js"
import style0 from "./outpost.vue?vue&type=style&index=0&id=8a42c810&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports